module.exports = __webpack_public_path__ + "static/media/logo3.f1772397.png";